import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53ac721b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "editable-package-field" }
const _hoisted_2 = { class: "editable-package-field__package-names" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.packages, (packageItem, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(packageItem), 1))
      }), 128))
    ]),
    _createVNode(_component_q_btn, {
      onClick: _ctx.onChangePackages,
      class: "editable-package-field__edit-icon",
      color: "grey-7",
      flat: "",
      round: "",
      icon: "mdi-pencil-outline"
    }, null, 8, ["onClick"])
  ]))
}